import './App.css';
import * as React from "react"
import { ThemeProvider } from '@mui/material/styles';
import {AppBar, Box, ImageList, ImageListItem, ImageListItemBar, Link, Toolbar, Typography } from "@mui/material";
import CallRoundedIcon from '@mui/icons-material/CallRounded';
import { theme } from './theme';
import SalonImg from './images/salon.jpg'
import Nota2025 from './images/nota2025.png'
import imagenes from './imagenes'
import Map from './components/map';
import MailRounded from '@mui/icons-material/MailRounded';
import ScrollDialog from './components/image-gallery-dialog';

const sections = [
  "Instalaciones",
  "Galería de Imágenes",
  "Ubicación",
  "Contacto y Reservas",
]

const instalaciones = [
  "La Casa Rural El Horno de la Aldegüela se encuentra en Torrecaballeros, a 10 minutos de Segovia. El alojamiento está completamente equipado, con cocina completa y 5 habitaciones. Las estancias compartidas tienen calefacción por bomba de calor/frío. Durante los meses de invierno también se dispone de chimenea en un acogedor salon, con zona de estar, TV de pantalla plana y mesa de comedor para al menos 12 personas.",
  "Cada habitación cuenta con una cama de matrimonio, así como un baño completo individual con calefacción y ventiladores. En ellas encontrarán ropa de cama y las toallas necesarias para la estancia.",
  "En el exterior dispone de una piscina de verano, con barbacoa y terraza con espacio de sobra para comer. Con dos mesas para 6 comensales cada una, ubicadas bajo un porche que proporciona sombra durante la tarde",
]

const bookingLink = "https://www.booking.com/hotel/es/casa-rural-el-horno-de-la-aldeguela.es.html"
const airbnbLink = "https://www.airbnb.es/rooms/1098479354354849941"

const sectionStyles = {
  m:2, mb:5, textAlign: 'center'
}

function App() {
  const [openImageDialog, setOpenImageDialog] = React.useState(null)

  const instalacionesRef = React.useRef(null);
  const galeriaRef = React.useRef(null);
  const ubicacionRef = React.useRef(null);
  const contactoRef = React.useRef(null);
  const refs = [instalacionesRef, galeriaRef, ubicacionRef, contactoRef];

  const clickOnRef = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" })
  }

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="sticky">
        <Toolbar sx={{display: 'flex', flexWrap:'wrap'}}>
          <Box m={2}>
            <Typography variant="h6" component="div" noWrap>Casa Rural El Horno de la Aldegüela</Typography>
          </Box>
          <Box m={2} sx={{display: 'flex', overflowX: 'auto'}}>
          {
            sections.map((s, idx) => (
              <Box m={2} onClick={() => clickOnRef(refs[idx])} sx={{flexGrow: 0, cursor: 'pointer'}}>
                <Typography noWrap>{s}</Typography>
              </Box>
            ))
          }
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{}}>
        <Box sx={{width: '100%', height: '550px', background: 'black', display: 'flex', justifyContent: 'center'}}>
          <img src={SalonImg} width='80%' height={'100%'} alt={'presentacion'}/>
          <Box>
            <img src={Nota2025} width={'200px'} alt={'nota 2025'}/>
          </Box>
        </Box>
        <Box sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', ml:'10%', mr:'10%'}}>
            <Box sx={{width: '100%'}}>
              <Box sx={sectionStyles}>
                <Typography ref={instalacionesRef} variant="h5">{sections[0]}</Typography>
                {instalaciones.map((i) => (
                  <Box sx={{m:2, textAlign: 'justify'}}>
                    <Typography>{i}</Typography>
                  </Box>
                ))}
              </Box>
              <Box sx={sectionStyles}>
                <Typography ref={galeriaRef} variant="h5">{sections[1]}</Typography>
                <Box sx={{ m:2, height: 500, overflowY: 'scroll' }}>
                  <ImageList  variant="masonry" cols={3} gap={8}>
                    {imagenes.map((item, idx) => (
                      <ImageListItem key={item.img} onClick={() => setOpenImageDialog(idx)} sx={{cursor: 'pointer'}}>
                        <img
                          srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                          src={`${item.img}?w=248&fit=crop&auto=format`}
                          alt={item.title}
                          loading="lazy"
                        />
                        <ImageListItemBar
                          title={item.title}
                        />
                      </ImageListItem>
                    ))}
                  </ImageList>
                </Box>
              </Box>
              <Box sx={sectionStyles}>
                <Typography ref={ubicacionRef} variant="h5">{sections[2]}</Typography>
                  <Box sx={{ m:2 }}>
                    <Map/>
                  </Box>
                  <Typography>Calle Fanega, 1</Typography>
                  <Typography>40160, Torrecaballeros (Segovia)</Typography>
              </Box>
              <Box sx={sectionStyles}>
                <Typography ref={contactoRef} variant="h5">{sections[3]}</Typography>
                  <Box sx={{ m:2 }}>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap:2}}>
                      <Box sx={{display: 'flex', gap: 2}}>
                        <CallRoundedIcon/>
                        <a href="tel:+34667591369"><Typography variant="h5">+34 667591369</Typography></a>
                      </Box>
                      <Box sx={{display: 'flex', gap: 2}}>
                        <MailRounded/>
                        <a href="mailto:casaruralelhorno@gmail.com"><Typography variant="h5">casaruralelhorno@gmail.com</Typography></a>
                      </Box>
                    </Box>
                  </Box>
              </Box>
            </Box>
        </Box>
        <Box sx={{width:'100%', background: '#212323', justifyContent: 'center', alignItems:'center', color: 'white', display: 'flex', gap:3, minHeight: '3em'}}>
          <Link href={bookingLink} target="_blank" underline="hover" sx={{color:'white'}}>
            Booking
          </Link>
          <Link href={airbnbLink} target="_blank" underline="hover" sx={{color:'white'}}>
            AirBnb
          </Link>
        </Box>
      </Box>
      <ScrollDialog
        open={openImageDialog !== null}
        images={imagenes}
        active={openImageDialog}
        handleNext={() => setOpenImageDialog(Math.min(openImageDialog+1, imagenes.length-1))}
        handleBack={() => setOpenImageDialog(Math.max(openImageDialog-1, 0))}
        handleClose={() => setOpenImageDialog(null)}
      />
    </ThemeProvider>
  );
}

export default App;
